module.exports = __webpack_public_path__ + "img/web_500x800.86121a05.jpg";